import AxiosStatic from 'axios';
import { ConfirmAgeResponse } from '../types/account.type';
import { API_ENDPOINTS } from '../constants/api';
import axios from './client';

export class AccountService {
    static async confirmAge(dateOfBirth?: string): Promise<ConfirmAgeResponse> {
        try {
            const requestData = dateOfBirth ? { dateOfBirth } : {};
            const response = await axios.post<ConfirmAgeResponse>(
                API_ENDPOINTS.CONFIRM_AGE,
                requestData
            );
            if (response.data.status === 'OK') {
                return response.data;
            } else {
                throw new Error('Failed to confirm age:');
            }
        } catch (error) {
            if (AxiosStatic.isAxiosError(error)) {
                throw new Error(error?.response?.data?.errorCode);
            }
            throw new Error('Unknown error occurred');
        }
    }
}
